const validatePin = (pin) => {
  return typeof pin === "string" && pin.length > 3;
};

export default validatePin;
